/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5l39micgv3.execute-api.eu-west-1.amazonaws.com/staging",
            "region": "eu-west-1"
        },
        {
            "name": "authUtils",
            "endpoint": "https://sz0dcqqxwl.execute-api.eu-west-1.amazonaws.com/staging",
            "region": "eu-west-1"
        },
        {
            "name": "utils",
            "endpoint": "https://1ndg7wh600.execute-api.eu-west-1.amazonaws.com/staging",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://eyygqwwmlbbgfkmjb3vbvrknni.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-mb4lsptzhrbinpfpipfcqlwfa4",
    "aws_cognito_identity_pool_id": "eu-west-1:c650c572-5f99-48df-a33d-8b982ecb8d5c",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_pzdEn4thd",
    "aws_user_pools_web_client_id": "amkncfri73l90uh1dihvdhf7n",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "senseus-content113534-staging",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
